import { render, staticRenderFns } from "./selectType.vue?vue&type=template&id=231d3ad4&scoped=true"
import script from "./selectType.vue?vue&type=script&lang=js"
export * from "./selectType.vue?vue&type=script&lang=js"
import style0 from "./selectType.vue?vue&type=style&index=0&id=231d3ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d3ad4",
  null
  
)

export default component.exports